import { render } from "./Home.vue?vue&type=template&id=9a5fa10a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=9a5fa10a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9a5fa10a"

export default script